var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountryflag4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10579_209362)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    transform: "translate(0.929688 0.271484)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1776 11.5717C17.5146 10.6634 17.6991 9.68089 17.6991 8.65527C17.6991 7.62965 17.5146 6.64724 17.1776 5.73887L9.31438 5.00977L1.45121 5.73887C1.11418 6.64724 0.929688 7.62965 0.929688 8.65527C0.929688 9.68089 1.11418 10.6634 1.45121 11.5717L9.31438 12.3008L17.1776 11.5717Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31242 17.0406C12.9175 17.0406 15.9909 14.7652 17.1756 11.5723H1.44922C2.63395 14.7652 5.70727 17.0406 9.31242 17.0406Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31242 0.271484C5.70727 0.271484 2.63395 2.54688 1.44922 5.73978H17.1756C15.9909 2.54688 12.9175 0.271484 9.31242 0.271484Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10579_209362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    fill: "white",
    transform: "translate(0.929688 0.271484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryflag4);
export default __webpack_public_path__ + "static/media/Countryflag4.b27493f0f749b02444506cffa880b421.svg";
export { ForwardRef as ReactComponent };